import React from "react";

const RequredStar = ({ field }) => {
    if (!field.settings.label) return;

    return field.settings.validation_rules?.required?.value ? <span className="jlt-text-red-600">*</span> : null;
};

export default RequredStar;
